import React, { useContext, useEffect, useState } from 'react'

//imagenes
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import departamentosIcon from "../../assets/img/departamentos.svg";
import { useParams, useNavigate } from 'react-router-dom';
import ConexContext from '../../context/ConexContext';
import { formatFecha } from '../JS/formato';
import ModalGenericoUsuario from '../modales/ModalGenericoUsuario';

const PerfilDepartamento = ({nuevo}) => {
	const { peticion, tipo_usuario, id_usuario } = useContext(ConexContext);
	const { departamento } = useParams();
	const navigate = useNavigate();

	const [datosDepartCopy, setDatosDepartCopy] = useState(null); //datos del departamento copia
	const [datosDepart, setDatosDepart] = useState(null); //datos del departamento

	const [mensaje, setMensaje] = useState(null); //mensaje
	const [error, setError] = useState(null); //mensaje de error

	const [modalCrear, setmodalCrear] = useState(false); //modal crear departamento
	const [datosEntidades, setDatosEntidades] = useState(null); //datos de las entidades
	const [datosEmpresas, setDatosEmpresas] = useState(null); //datos de las empresas
	const [datosDepartamentos, setDatosDepartamentos] = useState(null); //datos de los departamentos

	/**
	 * Carga los datos del departamento y los select
	 */
	useEffect(() => {
		const datos_depart = async () => {
			setMensaje(null);
			//departamentos
			peticion(`/distinc_select`, {
				method: "POST",
				json: {
					"campos": ["cod_ent", "cod_emp", "cod_dpto", "nombre_dpto"],
					"tabla": "i6departamento"
				},
			})
			.then(res => {
				if (res?.estado ?? true) return setMensaje("Se ha producido un error");
				if (res?.res ?? false) setDatosDepartamentos(res["res"]["res"]);
			})
			.catch(error => {
				setMensaje("Se ha producido un error");
			});				
			if(!nuevo){ //si estoy consultando un departamento existente
				let res = await peticion(`/datos_departamento?departamento=${departamento.split('_')[0]}&entidad=${departamento.split('_')[2]}&empresa=${departamento.split('_')[1]}`, { method: 'GET' });
				if (res?.estado ?? true) return setMensaje('Se ha producido un error');
				if (res?.res ?? false) {
					res["res"]["posicion"] = res["res"]["cod_dpto"];
					setDatosDepart(res["res"]);
					setDatosDepartCopy(res["res"]);
				} else {
					setMensaje(res?.mensaje ?? 'Error al cargar los datos del departamento');
				}
			}else{ //si estoy creando un nuevo departamento
				//cargar los datos de los select
				//entidades
				peticion(`/distinc_select`, {
					method: "POST",
					json: {
						"campos": ["cod_ent", "nombre_ent"],
						"tabla": "i6entidad"
					},
				})
				.then(res => {
					if (res?.estado ?? true) return setMensaje("Se ha producido un error");
					if (res?.res ?? false) setDatosEntidades(res["res"]["res"]);
				})
				.catch(error => {
					setMensaje("Se ha producido un error");
				});
				//empresas
				peticion(`/distinc_select`, {
					method: "POST",
					json: {
						"campos": ["cod_ent", "cod_emp", "nombre_emp"],
						"tabla": "i6empresa"
					},
				})
				.then(res => {
					if (res?.estado ?? true) return setMensaje("Se ha producido un error");
					if (res?.res ?? false) setDatosEmpresas(res["res"]["res"]);
				})
				.catch(error => {
					setMensaje("Se ha producido un error");
				});
			}
		}
		//si es nuevo, pongo los datos vacíos
		if (nuevo) {
			setDatosDepart({
				"cod_dpto": "",
				"cod_emp": "",
				"cod_ent": "",
				"fecha_alta_dpto": "",
				"nombre_dpto": "",
				"padre": ""
			})
			datos_depart();
			return
		}
		//si es un departamento existente, cargo los datos
		if (departamento && ((tipo_usuario === '5' || tipo_usuario === '2' || tipo_usuario === '3' || tipo_usuario === '0')))
			datos_depart();
		else //si no, muestra mensaje de error
			setMensaje('No tienes permisos para ver este departamento');
	// eslint-disable-next-line
	}, [departamento, tipo_usuario, id_usuario, peticion, nuevo]);

	/**
	 * Obtiene las diferencias entre dos objetos
	 * @param {Object} obj1 
	 * @param {Object} obj2 
	 * @returns las diferencias entre los dos objetos
	 */
	const getDiferentes = (obj1, obj2) => {
		const diferentes = {};
		for (const key in obj2) {
			if (obj1[key] !== obj2[key]) {
				diferentes[key] = obj2[key];
			}
		}
		return diferentes;
	};
	
	/**
	 * Comprueba si los campos están rellenos y correctos
	 * @returns si los campos están rellenos y correctos
	 */
	const comprobarCampos = () => {
		//comprobar si tengo todos los campos
		if (
			!datosDepart.cod_emp ||
			!datosDepart.cod_ent ||
			!datosDepart.nombre_dpto ||
			!datosDepart.padre ||
			!datosDepart.posicion 
		) {
			setError("Faltan campos por rellenar");
			return false;
		}

		return true;
	}

	/**
	 * Modifica los datos del departamento
	 */
	const modDepart = async () => {
		if (!comprobarCampos()) return;
		if ((datosDepart.padre !== datosDepartCopy.padre) || (datosDepart.posicion !== datosDepartCopy.posicion)) 
			datosDepart.padre_anterior = datosDepartCopy.padre;
		// return
		const res = await peticion(`/guardar_datos_departamento`, {
			method: 'POST', json: datosDepart
		});
		if (res?.estado ?? true) return setMensaje('Se ha producido un error'); //error
		if (res?.mensaje !== 'OK' ?? false) return setMensaje(res?.mensaje ?? 'Error al cambiar el departamento '+departamento.split('_')[0]+''); //errores
		setDatosDepartCopy({ ...datosDepart });
		navigate('/administracion/departamentos')
	}
	/**
	 * Crear un departamento
	 */
	const crearDepart = async () => {
		if (!comprobarCampos()) return;
		const res = await peticion(`/crear_departamento`, {
			method: 'POST', json: datosDepart
		});
		if (res?.estado ?? true) return setMensaje('Se ha producido un error. ' + res.mensaje); //error
		if (res?.mensaje !== 'OK' ?? false) return setMensaje(res?.mensaje ?? 'Error al crear el departamento '+datosDepart.nombre_dpto); //errores
		return 0;
	}

	/**
	 * Genera las opciones del select de departamentos de forma recursiva, anidando los hijos
	 * @param {Object} departamentos 
	 * @param {Number} nivel 
	 * @returns Options para el select de departamentos
	 */
	const generarOpcionesSelectDpto = (departamentos, nivel = 0) => {
		const tab = String.fromCharCode(0x2003).repeat(nivel); //añade tabulaciones según el nivel
		return departamentos
			.sort((a, b) => parseInt(a.cod_dpto)>parseInt(b.cod_dpto)?1:-1)
			.map(departamento => {
				if(departamento.cod_ent !== datosDepart.cod_ent || departamento.cod_emp !== datosDepart.cod_emp) return null; //muestra solo los departamentos de la entidad y empresa seleccionada
				return (
					<React.Fragment key={departamento.cod_dpto + departamento.cod_ent + departamento.cod_emp}>
						<option value={departamento.cod_dpto}>
							{tab}{`${departamento.nombre_dpto} `}({`${departamento.cod_dpto}`})
						</option>
						{departamento.hijos && departamento.hijos.length > 0 &&
							generarOpcionesSelectDpto(departamento.hijos, nivel + 1)
						}
					</React.Fragment>
				);
		});
	}

	/**
	 * Genera las opciones del select de posiciones con los hijos del padre
	 * @param {Object} departamentos 
	 * @param {String} padre 
	 * @returns Options para el select de posiciones
	 */
	const generarOpcionesSelectPos = (departamentos, padre) => {
		return departamentos
			.sort((a, b) => parseInt(a.cod_dpto)>parseInt(b.cod_dpto)?1:-1)
			.map(departamento => {
				if(departamento.cod_ent !== datosDepart.cod_ent || departamento.cod_emp !== datosDepart.cod_emp) return null;
				return (
					<React.Fragment key={departamento.cod_dpto + departamento.cod_ent + departamento.cod_emp}>
						{departamento.cod_dpto === padre ?
							departamento.hijos.map(hijo => {
								return (
									<option value={hijo.cod_dpto} key={hijo.cod_dpto + hijo.cod_ent + hijo.cod_emp}>
										{`${hijo.nombre_dpto} `}({`${hijo.cod_dpto}`})
									</option>
								)
							})
						:
						generarOpcionesSelectPos(departamento.hijos, padre)
						}
					</React.Fragment>
				);
		});
	}

	return (
		<>
			<div className="col-xs-12 tabla" id='user-mng' >
			<div
				className="breadcrumbs"
				>
					<span 
					onClick={() => {
						navigate("/administracion/departamentos");
					}}
					>Departamentos</span>
					/ {nuevo ? "Nuevo departamento" : datosDepartCopy?.nombre_dpto.toString()}
				</div>
				<div className='section-header'>
					<div className='img-container'>
						<img src={departamentosIcon} alt=''></img>
					</div>
					<div>
						<h2>Departamento</h2>
						<h3>
							{/* <strong>Listado</strong> /  */}
							{nuevo ? ('Nuevo departamento'):(datosDepartCopy?.nombre_dpto ?? '')}
							{/* {nuevo ? (''):(datosUsu?.cod_dpto ?? '')}
							{nuevo ? (''):(datosUsu?.cod_emp ?? '')}
							{nuevo ? (''):(datosUsu?.cod_ent ?? '')} */}
						</h3>
					</div>
				</div>
				<main>
					{(!datosDepart && !mensaje) ? //si no hay datos ni mensaje, está cargando
						<h1 className="cargando">Cargando...</h1>
						: mensaje ? //si hay mensaje, muestra el mensaje (error)
							<h1 className="cargando">{mensaje}</h1>
							: //si hay datos, muestra los datos
							<>
								<form>
									<div className='form-item'>
										<label>Entidad</label>
										{nuevo ? (
											<select 
												value={datosDepart?.cod_ent ?? ''}
												onChange={(e) => setDatosDepart({ ...datosDepart, cod_ent: e.target.value, cod_emp: '', cod_dpto: '', padre: '', posicion: '' })}
											>
												<option value="">Selecciona una entidad</option>
												{datosEntidades &&
													datosEntidades.map((entidad) => (
														<option value={entidad.cod_ent} key={entidad.cod_ent}>
															{entidad.nombre_ent} ({entidad.cod_ent})
														</option>
												))}
											</select>
											
										):(
											<input
												type='text'
												placeholder='Código de entidad'
												value={datosDepart?.nombre_ent ?? ''}
												disabled={true}
												className={"disabled"}
												maxLength={4}
												onChange={(e) => setDatosDepart({ ...datosDepart, cod_ent: e.target.value })}
											/>
										)
										}
										
									</div>
									<div className='form-item'>
										<label>Empresa</label>
										{nuevo ? (
											<select 
												value={datosDepart?.cod_emp ?? ''}
												onChange={(e) => setDatosDepart({ ...datosDepart, cod_emp: e.target.value, cod_dpto: '', padre: '', posicion: '' })}
											>
												<option value="">Selecciona una empresa</option>
												{datosEmpresas &&
													datosEmpresas
														.filter((empresa) => empresa.cod_ent === datosDepart.cod_ent)
														.map((empresa) => (
															<option value={empresa.cod_emp} key={empresa.cod_emp}>
																{empresa.nombre_emp} ({empresa.cod_emp})
															</option>
												))}
											</select>
										):(
											<input
												type='text'
												placeholder='Código de empresa'
												value={datosDepart?.nombre_emp ?? ''}
												disabled={true}
												className={"disabled"}
												maxLength={10}
												onChange={(e) => setDatosDepart({ ...datosDepart, cod_emp: e.target.value })}
											/>
										)}
										
									</div>
									<div className='form-item'>
										<label>Nombre de departamento</label>
										<input
											type='text'
											placeholder='Nombre de departamento'
											value={datosDepart?.nombre_dpto ?? ''}
											disabled={false}
											className={""}
											maxLength={30}
											onChange={(e) => setDatosDepart({ ...datosDepart, nombre_dpto: e.target.value })}
										/>
									</div>
									<div className='form-item'>
										<label>Departamento padre</label>
										{datosDepartamentos && 
											<select 
												value={datosDepart?.padre ?? ''}
												onChange={(e) => setDatosDepart({ ...datosDepart, padre: e.target.value, posicion: '' })}
											>
												<option value="">Seleccione un departamento padre</option>
												{datosDepartamentos &&
													generarOpcionesSelectDpto(datosDepartamentos)
												}
											</select>
										}
									</div>
									{!nuevo && 
									<div className='form-item'>
										<label>Código de departamento</label>
										<input
											type='text'
											placeholder='Código de departamento'
											value={datosDepart?.cod_dpto ?? ''}
											disabled={true}
											className={"disabled"}
											maxLength={12}
											onChange={(e) => setDatosDepart({ ...datosDepart, cod_dpto: e.target.value })}
										/>
									</div>
									}
									<div className='form-item'>
										<label>Posición</label>
										{datosDepartamentos && 
											<select 
												value={datosDepart?.posicion ?? ''}
												onChange={(e) => setDatosDepart({ ...datosDepart, posicion: e.target.value })}
												disabled={datosDepart.padre === '' ? true : false}
											>
												<option value="">Seleccione posición</option>
												{datosDepartamentos && datosDepart.padre &&
													generarOpcionesSelectPos(datosDepartamentos, datosDepart.padre)
												}
												<option value="nuevo">Nuevo</option>
											</select>
										}
									</div>
									{!nuevo &&
									<div className='form-item'>
										<label>Fecha de alta</label>
										<input
											type='text'
											placeholder='Fecha de alta'
											value={formatFecha(datosDepart.fecha_alta_dpto.toString(), "ISO8601", "esp") ??  'No hay fecha de alta'}
											disabled={true}
											className={"disabled"}
											onChange={(e) => {}}
										/>
									</div>
									}
								</form>
								<div className='button-container'>
								{!nuevo ?
										(
										<>
											<button className={(datosDepartCopy && datosDepart && (Object.keys(getDiferentes(datosDepartCopy, datosDepart)).length === 0))?('cta desactiva'):('cta')} onClick={() => modDepart()}>Guardar</button>
										</>
										):(
											<button onClick={() => { if (comprobarCampos()) setmodalCrear(true) }}>Crear departamento</button>
										)
									}
								</div>
								<p>{error}</p>
							</>
					}
				</main>
				<ModalGenericoUsuario
					texto1={"¿Quiere crear este departamento?"}
					texto2={"Departamento creado correctamente"}
					texto3={"Crear departamento"}
					texto4={mensaje}
					setMensaje={setMensaje}
					navegar={() => navigate('/administracion/departamentos')}
					show={modalCrear}
					onHide={() => setmodalCrear(false)}
					func={crearDepart}
				/>
			</div>
		</>
	)
}

export default PerfilDepartamento